import { BitePorterApplication, BiteServiceName, BiteServicePorts, Environment } from "@biteinc/enums";
//#region src/bite_service_url.ts
const HTTP_SERVICE_URL_CONFIGS = [
	{
		serviceName: BiteServiceName.Bureau,
		urlEnvVar: "BUREAU_URL",
		internalUrlEnvVar: "BUREAU_INTERNAL_URL",
		port: BiteServicePorts.Bureau,
		porterApplicationByEnv: {
			[Environment.PROD]: BitePorterApplication.BureauProd,
			[Environment.STAGING]: BitePorterApplication.BureauStaging,
			[Environment.SANDBOX]: BitePorterApplication.BureauSandbox
		}
	},
	{
		serviceName: BiteServiceName.Flash,
		urlEnvVar: "FLASH_URL",
		internalUrlEnvVar: "FLASH_INTERNAL_URL",
		port: BiteServicePorts.Flash,
		porterApplicationByEnv: {
			[Environment.PROD]: BitePorterApplication.FlashProd,
			[Environment.STAGING]: BitePorterApplication.FlashStaging,
			[Environment.SANDBOX]: BitePorterApplication.FlashSandbox
		}
	},
	{
		serviceName: BiteServiceName.Garcon,
		urlEnvVar: "GARCON_URL",
		internalUrlEnvVar: "GARCON_INTERNAL_URL",
		port: BiteServicePorts.Garcon,
		porterApplicationByEnv: {
			[Environment.PROD]: BitePorterApplication.GarconProd,
			[Environment.STAGING]: BitePorterApplication.GarconStaging,
			[Environment.SANDBOX]: BitePorterApplication.GarconSandbox
		}
	},
	{
		serviceName: BiteServiceName.Maitred,
		urlEnvVar: "MAITRED_URL",
		internalUrlEnvVar: "MAITRED_INTERNAL_URL",
		port: BiteServicePorts.Maitred,
		porterApplicationByEnv: {
			[Environment.PROD]: BitePorterApplication.MaitredProd,
			[Environment.STAGING]: BitePorterApplication.MaitredStaging,
			[Environment.SANDBOX]: BitePorterApplication.MaitredSandbox
		}
	},
	{
		serviceName: BiteServiceName.RecommendationApp,
		urlEnvVar: "RECOMMENDATION_APP_URL",
		internalUrlEnvVar: "RECOMMENDATION_APP_INTERNAL_URL",
		port: BiteServicePorts.RecommendationApp,
		porterApplicationByEnv: {
			[Environment.PROD]: BitePorterApplication.RecommendationAppProd,
			[Environment.STAGING]: BitePorterApplication.RecommendationAppStaging,
			[Environment.SANDBOX]: BitePorterApplication.RecommendationAppSandbox
		}
	},
	{
		serviceName: BiteServiceName.Vitrine,
		urlEnvVar: "VITRINE_URL",
		internalUrlEnvVar: "VITRINE_INTERNAL_URL",
		port: BiteServicePorts.Vitrine,
		porterApplicationByEnv: {
			[Environment.PROD]: BitePorterApplication.VitrineProd,
			[Environment.STAGING]: BitePorterApplication.VitrineStaging,
			[Environment.SANDBOX]: BitePorterApplication.VitrineSandbox
		}
	},
	{
		serviceName: BiteServiceName.WebhookReceiver,
		urlEnvVar: "WEBHOOK_RECEIVER_URL",
		internalUrlEnvVar: "WEBHOOK_RECEIVER_INTERNAL_URL",
		port: BiteServicePorts.WebhookReceiver,
		porterApplicationByEnv: {
			[Environment.PROD]: BitePorterApplication.WebhookReceiverProd,
			[Environment.STAGING]: BitePorterApplication.WebhookReceiverStaging,
			[Environment.SANDBOX]: BitePorterApplication.WebhookReceiverSandbox
		}
	}
];
const HTTP_SERVICE_URL_CONFIG_BY_NAME = new Map(HTTP_SERVICE_URL_CONFIGS.map((config) => [config.serviceName, config]));
function getHttpServiceUrlConfig(serviceName) {
	return HTTP_SERVICE_URL_CONFIG_BY_NAME.get(serviceName);
}
function httpServiceUrlConfigs() {
	return HTTP_SERVICE_URL_CONFIGS;
}
const EXTRA_PROXY_URL_ENV_BY_PORT = {
	[BiteServicePorts.ChromeOsApp]: "CHROMEOS_APP_URL",
	[BiteServicePorts.Pinata]: "PINATA_URL",
	[BiteServicePorts.McpApp]: "MCP_APP_URL",
	[BiteServicePorts.Eclair]: "ECLAIR_URL"
};
function proxyUrlEnvByPort() {
	return {
		...Object.fromEntries(HTTP_SERVICE_URL_CONFIGS.map((config) => [config.port, config.urlEnvVar])),
		...EXTRA_PROXY_URL_ENV_BY_PORT
	};
}
//#endregion
export { getHttpServiceUrlConfig, httpServiceUrlConfigs, proxyUrlEnvByPort };

//# sourceMappingURL=bite_service_url.js.map